import isObject from 'lodash/isObject';

const REQUIRED_SIGNALS = ['ad_storage', 'analytics_storage', 'ad_user_data', 'ad_personalization'];

const isGrantedConsentDefault = (entry: Record<string, unknown>): boolean => {
  const signals = entry?.[2];

  return (
    entry?.[0] === 'consent' &&
    entry?.[1] === 'default' &&
    isObject(signals) &&
    REQUIRED_SIGNALS.every((signal) => Reflect.get(signals, signal) === 'granted')
  );
};

export const hasGrantedConsentDefaultInDataLayer = (): boolean =>
  typeof window !== 'undefined' &&
  Array.isArray(window.dataLayer) &&
  window.dataLayer.some(isGrantedConsentDefault);
